
import { AllLabels } from '@/interfaces';
import { labelsStore } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
  components: {
  }
})
export default class ErrorPage extends Vue {

  @Prop({ default: '500' })
  public statusCode!: string;

  public get labels(): AllLabels {
    return labelsStore.labels;
  }
}

